import { render, staticRenderFns } from "./PershingEmployerRisk.vue?vue&type=template&id=67c6b8eb&scoped=true"
import script from "./PershingEmployerRisk.vue?vue&type=script&lang=js"
export * from "./PershingEmployerRisk.vue?vue&type=script&lang=js"
import style0 from "./PershingEmployerRisk.vue?vue&type=style&index=0&id=67c6b8eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6b8eb",
  null
  
)

export default component.exports